import {IResult, IQueryParameter, IPointGeometry, IOverlay} from "@/types/map";
import {loadModules} from "esri-loader";
import ToolTip from "../../Overlays/arcgis/ToolTip";

export class QueryIntersect {
  private static intances: Map<string, any>;
  private overlayers!: __esri.GraphicsLayer;
  private view!: any;
  private pointLayer!: __esri.FeatureLayer;
  private tooltip!: any;
  private selectTip!: any;
  private clickHandler!: any;
  private selectGraphic!: any;

  private constructor(view: any) {
    this.view = view;
  }
  private async initialize() {
    if (this.selectTip) {
      this.selectTip.remove();
      this.selectTip = null;
    }
    if (this.pointLayer) {
      this.view.map.remove(this.pointLayer);
    }
    type MapModules = [typeof import("esri/layers/GraphicsLayer")];
    const [GraphicsLayer] = await (loadModules([
      "esri/layers/GraphicsLayer"
    ]) as Promise<MapModules>);
    if (!this.overlayers) {
      this.overlayers = new GraphicsLayer();
      this.view.map.add(this.overlayers, 0);
    } else {
      this.overlayers.removeAll();
    }
    let _this = this;
    if (!this.clickHandler) {
      this.clickHandler = this.view.on("click", async (event: any) => {
        const response = await _this.view.hitTest(event);
        if (response.results.length > 0) {
          let result = response.results[0];
          const graphic = result.graphic;
          if (_this.pointLayer.id === graphic.layer.id) {
            if (_this.selectTip) {
              _this.selectTip.remove();
              _this.selectTip = null;
            }
            if (this.selectGraphic) {
              _this.updateLayer(this.selectGraphic, "");
            }
            _this.updateLayer(graphic, "select");
            if (_this.tooltip) {
              _this.selectTip = new ToolTip(
                this.view,
                {
                  vue: _this.tooltip,
                  anchor: "bottom",
                  yoffset: 0,
                  ...graphic.attributes
                },
                graphic
              );
            }
          }
        } else {
          if (_this.selectTip) {
            _this.selectTip.remove();
            _this.selectTip = null;
          }
          if (this.selectGraphic) {
            _this.updateLayer(this.selectGraphic, "");
          }
        }
      });
    }
  }
  public static getInstance(view: any) {
    const id = view.container.id;
    if (!QueryIntersect.intances) {
      QueryIntersect.intances = new Map();
    }
    let intance = QueryIntersect.intances.get(id);
    if (!intance) {
      intance = new QueryIntersect(view);
      QueryIntersect.intances.set(id, intance);
    }
    return intance;
  }
  public async deleteQueryIntersect(param: string | undefined) {
    let delTip = param === "tip";
    if (!delTip) {
      if (this.pointLayer) {
        this.view.map.remove(this.pointLayer);
      }
      if (this.overlayers) {
        this.overlayers.removeAll();
      }
    }
    if (this.selectTip) {
      this.selectTip.remove();
      this.selectTip = null;
    }
    if (this.selectGraphic) {
      this.updateLayer(this.selectGraphic, "");
    }
  }
  public async addQueryIntersect(params: IQueryParameter) {
    await this.initialize();
    let label = params.label;
    let points = params.points;
    this.tooltip = params.tooltip;
    let selectLayer;

    //找出图层
    this.view.map.allLayers.forEach((baselayer: any) => {
      if (label === baselayer.label) {
        selectLayer = baselayer;
      }
    });
    if (selectLayer) {
      let features = await this.doQueryArea(selectLayer, points);
      if (features) {
        this.createPointLayer(points, features);
        this.view.goTo({target: features});
      }
    }
  }
  private async createPointLayer(points: IOverlay[], features: any[]) {
    type MapModules = [
      typeof import("esri/Graphic"),
      typeof import("esri/geometry/Point"),
      typeof import("esri/layers/FeatureLayer")
    ];
    const [Graphic, Point, FeatureLayer] = await (loadModules([
      "esri/Graphic",
      "esri/geometry/Point",
      "esri/layers/FeatureLayer"
    ]) as Promise<MapModules>);
    let graphics: any[] = [];
    points.forEach((point: IOverlay) => {
      let pt: any = new Point({
        longitude: (point.geometry as IPointGeometry).x,
        latitude: (point.geometry as IPointGeometry).y
      });
      let filterFeatures = features.filter((graphic) => {
        if (graphic.geometry.contains(pt)) {
          return true;
        }
        return false;
      });
      if (filterFeatures.length > 0) {
        graphics.push(
          new Graphic({
            geometry: filterFeatures[0].geometry.centroid,
            attributes: {
              FEATURETYPE: filterFeatures[0].attributes["XQLX"],
              ...point.fields,
              ...filterFeatures[0].attributes
            }
          })
        );
      }
    });
    let fields: any[] = [
      {
        name: "ObjectID",
        alias: "ObjectID",
        type: "oid"
      }
    ];
    let overlay = graphics[0];
    for (let str in overlay.attributes) {
      let fieldtype = "string";
      fields.push({name: str, alias: str, type: fieldtype});
    }
    this.pointLayer = new FeatureLayer({
      source: graphics,
      fields: fields,
      objectIdField: "ObjectID",
      geometryType: "point",
      outFields: ["*"],
      renderer: {
        type: "unique-value",
        field: "XQLX",
        defaultSymbol: {
          type: "picture-marker",
          url: "assets/mapIcons/PuDong/ic_danwei.png",
          width: 66,
          height: 80,
          yoffset: 30
        },
        uniqueValueInfos: [
          {
            value: "小区",
            symbol: {
              type: "picture-marker",
              url: "assets/mapIcons/PuDong/ic_xiaoqu.png",
              width: 66,
              height: 80,
              yoffset: 30
            }
          },
          {
            value: "小区_touch",
            symbol: {
              type: "picture-marker",
              url: "assets/mapIcons/PuDong/ic_xiaoqu_touch.png",
              width: 66,
              height: 80,
              yoffset: 30
            }
          },
          {
            value: "楼宇",
            symbol: {
              type: "picture-marker",
              url: "assets/mapIcons/PuDong/ic_danwei.png",
              width: 66,
              height: 80,
              yoffset: 30
            }
          },
          {
            value: "楼宇_touch",
            symbol: {
              type: "picture-marker",
              url: "assets/mapIcons/PuDong/ic_danwei_touch.png",
              width: 66,
              height: 80,
              yoffset: 30
            }
          }
        ]
      } as any,
      labelingInfo: [
        {
          labelExpressionInfo: {
            expression: "$feature.num"
          },
          useCodedValues: true,
          labelPlacement: "center-center",
          symbol: {
            type: "text", // autocasts as new TextSymbol()
            color: "white",
            yoffset: -3,
            xoffset: -1,
            font: {
              size: 12,
              weight: "normal"
            }
          } as any
        }
      ]
    });
    this.view.map.add(this.pointLayer);
  }
  private async updateLayer(graphic: any, type: string) {
    let newgraphic = graphic.clone();
    if (type == "touch") {
      newgraphic.attributes["XQLX"] =
        newgraphic.attributes["FEATURETYPE"] + "_touch";
    } else if (type == "select") {
      newgraphic.attributes["XQLX"] =
        newgraphic.attributes["FEATURETYPE"] + "_touch";
    } else {
      newgraphic.attributes["XQLX"] = newgraphic.attributes["FEATURETYPE"];
    }
    const edits = {updateFeatures: [newgraphic]};
    this.selectGraphic = newgraphic;
    await this.pointLayer.applyEdits(edits);
  }
  public async doQueryArea(layer: __esri.FeatureLayer, points: IOverlay[]) {
    type MapModules = [
      typeof import("esri/Graphic"),
      typeof import("esri/geometry/Multipoint")
    ];
    const [Graphic, Multipoint] = await (loadModules([
      "esri/Graphic",
      "esri/geometry/Multipoint"
    ]) as Promise<MapModules>);

    let multiPoint = points.map((point) => {
      return [
        (point.geometry as IPointGeometry).x,
        (point.geometry as IPointGeometry).y
      ];
    });

    let mtpoint = new Multipoint({
      points: multiPoint,
      spatialReference: {wkid: 4326}
    });

    const query = layer.createQuery();
    query.where = "1=1";
    query.returnGeometry = true;
    query.geometry = mtpoint;
    const features = (await layer.queryFeatures(query)).features;
    if (features.length > 0) {
      let graphics = features.map((graphic: any) => {
        return new Graphic({
          geometry: graphic.geometry,
          symbol: {
            type: "simple-fill",
            color: [255, 0, 0, 0.5],
            style: "solid",
            outline: {type: "simple-line", style: "none"}
          } as any,
          attributes: graphic.attributes
        });
      }, this);
      this.overlayers.addMany(graphics);
      return graphics;
    } else {
      return undefined;
    }
  }
}
